module.exports = __webpack_public_path__ + "img/carousel-vet-9.4349322e.jpg";